import { FirebaseError } from 'firebase/app'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth'
import React from 'react'
import { auth } from '../firebase'

export const clearFields = (refs: Array<React.MutableRefObject<HTMLInputElement | null>>) => {
  refs.forEach(ref => {
    if (ref && ref.current) {
      ref.current.value = ''
    }
  })
}

export const handleAuthError = (error: FirebaseError) => {
  const errorCode = error.code
  switch (errorCode) {
    case 'auth/email-already-in-use':
      return ('Ese correo ya está en uso')
    case 'auth/invalid-credential':
      return ('Los datos no son correctos')
    case 'auth/wrong-password':
      return ('Contraseña incorrecta')
    case 'auth/user-not-found':
      return ('El usuario no existe')
    default:
      return ('Ha ocurrido un error desconocido.')
  }
}

export const loginWithEmail = async (
  emailRef: React.MutableRefObject<HTMLInputElement | null>,
  passwordRef: React.MutableRefObject<HTMLInputElement | null>
) => {
  const email = emailRef.current?.value
  const password = passwordRef.current?.value
  if (!email || !password) return
  if (password.length < 6) return 'La contraseña debe tener al menos 6 caracteres'

  try {
    await signInWithEmailAndPassword(auth, email, password)
    clearFields([emailRef, passwordRef])
    return true
  } catch (error) {
    const errorMsg = handleAuthError(error as FirebaseError)
    return errorMsg
  }
}

// Crea el usuario en Firebase Auth con email + password. NO crea el Bar en
// Mongo ni actualiza el displayName — eso se hace en /onboarding tras la
// redirección, para que el flujo de signup por email sea consistente con el
// de Google (ambos pasan por la misma pantalla de onboarding).
export const handleSignIn = async (
  emailRef: React.MutableRefObject<HTMLInputElement | null>,
  passwordRef: React.MutableRefObject<HTMLInputElement | null>,
  repeatPasswordRef: React.MutableRefObject<HTMLInputElement | null>
) => {
  const email = emailRef.current?.value
  const password = passwordRef.current?.value
  const repeatPassword = repeatPasswordRef.current?.value
  if (!email || !password) return

  if (password.length < 6) {
    return 'La contraseña debe tener al menos 6 caracteres'
  }
  if (password !== repeatPassword) {
    return 'Las contraseñas no coinciden'
  }

  try {
    await createUserWithEmailAndPassword(auth, email, password)
    clearFields([emailRef, passwordRef, repeatPasswordRef])
    return true
  } catch (error) {
    console.error(error)
    const errorMsg = handleAuthError(error as FirebaseError)
    return errorMsg
  }
}

export const resetPassword = async (email: string) => {
  try {
    await sendPasswordResetEmail(auth, email)
    return true
  } catch (error) {
    console.error('Error en resetPassword:', error)
  }
}

export const getDeviceType = () => {
  if (typeof navigator === 'undefined') return 'pc' // Asumir PC en entorno no navegador

  const ua = navigator.userAgent

  if (/android/i.test(ua)) {
    return 'android'
  } else if (/iPhone|iPad|iPod/i.test(ua)) {
    return 'iphone'
  } else {
    return 'pc'
  }
}
